module.exports = __webpack_public_path__ + "static/During Work - 4-a04693d46c1b85da157f957ce3036c1e.jpg";